<div nz-row>
	<div nz-col nzSpan="24">
		<div nz-row>
			<div nz-col nzSpan="24">
				<app-splitbutton [elements]="[userAddButton1]" class="tablebutton"></app-splitbutton>
			</div>
		</div>
		<div nz-row>
			<div nz-col nzSpan="24">
				<nz-table #dynamicTable [nzData]="visibleParticipants" [nzBordered]="bordered"
							[nzSimple]="simple" [nzLoading]="loading" [nzPaginationPosition]="position" [nzShowSizeChanger]="sizeChanger"
							[nzFrontPagination]="pagination" [nzShowPagination]="pagination" [nzFooter]="footer ? 'Here is the Footer' : null"
							[nzTitle]="title ? 'Here is the Title' : null" [nzSize]="size"
							class="kit__utils__table" [hidden]="privacyMode" style="overflow-x: hidden">
					<thead>
					<tr *ngIf="header">
						<th nzWidth="150px" nzCustomFilter [nzSortFn]="compareUid">
							{{ 'user.uid' | translate}}
							<nz-filter-trigger [(nzVisible)]="uidFilterVisible" [nzActive]="uidFilterValue.length > 0" [nzDropdownMenu]="menuUid">
								<i nz-icon nzType="filter"></i>
							</nz-filter-trigger>
						</th>
						<th nzWidth="150px" nzCustomFilter [nzSortFn]="compareFirstname">
							{{ 'user.firstname' | translate}}
							<nz-filter-trigger [(nzVisible)]="firstNameFilterVisible" [nzActive]="firstNameFilterValue.length > 0"
												[nzDropdownMenu]="menuFirstName">
								<i nz-icon nzType="filter"></i>
							</nz-filter-trigger>
						</th>
						<th nzWidth="150px" nzCustomFilter [nzSortFn]="compareLastname">
							{{ 'user.surname' | translate}}
							<nz-filter-trigger [(nzVisible)]="lastNameFilterVisible" [nzActive]="lastNameFilterValue.length > 0"
												[nzDropdownMenu]="menuLastName">
								<i nz-icon nzType="filter"></i>
							</nz-filter-trigger>
						</th>
						<th nzWidth="100px" nzCustomFilter [nzSortFn]="compareBirthday">
							{{ 'user.birthday' | translate}}
							<nz-filter-trigger [(nzVisible)]="birthdayFilterVisible" [nzActive]="lastNameFilterValue.length > 0"
												[nzDropdownMenu]="menuBirthday">
								<i nz-icon nzType="filter"></i>
							</nz-filter-trigger>
						</th>
					</tr>
					</thead>
					<tbody>
					<ng-template ngFor let-data [ngForOf]="dynamicTable.data">
						<tr>
							<td>{{ data.id }}</td>
							<td>{{ data.data.personal.firstName }}</td>
							<td>{{ data.data.personal.lastName }}</td>
							<td>{{ data.data.personal.birthday }}</td>
						</tr>
					</ng-template>
					</tbody>
				</nz-table>
			</div>
		</div>
	</div>
</div>

<div nz-row>
	<div nz-col nzSpan="24">
		<div nz-row>
			<div nz-col nzSpan="24">
				<app-splitbutton [elements]="[userAddButton1]" class="tablebutton"></app-splitbutton>
			</div>
		</div>
		<div nz-row>
			<div nz-col nzSpan="24">
				<nz-table #dynamicTable [nzData]="visibleParticipants" [nzBordered]="bordered"
							[nzSimple]="simple" [nzLoading]="loading" [nzPaginationPosition]="position" [nzShowSizeChanger]="sizeChanger"
							[nzFrontPagination]="pagination" [nzShowPagination]="pagination" [nzFooter]="footer ? 'Here is the Footer' : null"
							[nzTitle]="title ? 'Here is the Title' : null" [nzSize]="size"
							class="kit__utils__table" [hidden]="privacyMode" style="overflow-x: hidden">
					<thead>
					<tr *ngIf="header">
						<th nzWidth="150px" nzCustomFilter [nzSortFn]="compareUid">
							{{ 'user.uid' | translate}}
							<nz-filter-trigger [(nzVisible)]="uidFilterVisible" [nzActive]="uidFilterValue.length > 0" [nzDropdownMenu]="menuUid">
								<i nz-icon nzType="filter"></i>
							</nz-filter-trigger>
						</th>
						<th nzWidth="150px" nzCustomFilter [nzSortFn]="compareFirstname">
							{{ 'user.firstname' | translate}}
							<nz-filter-trigger [(nzVisible)]="firstNameFilterVisible" [nzActive]="firstNameFilterValue.length > 0"
												[nzDropdownMenu]="menuFirstName">
								<i nz-icon nzType="filter"></i>
							</nz-filter-trigger>
						</th>
						<th nzWidth="150px" nzCustomFilter [nzSortFn]="compareLastname">
							{{ 'user.surname' | translate}}
							<nz-filter-trigger [(nzVisible)]="lastNameFilterVisible" [nzActive]="lastNameFilterValue.length > 0"
												[nzDropdownMenu]="menuLastName">
								<i nz-icon nzType="filter"></i>
							</nz-filter-trigger>
						</th>
						<th nzWidth="100px" nzCustomFilter [nzSortFn]="compareBirthday">
							{{ 'user.birthday' | translate}}
							<nz-filter-trigger [(nzVisible)]="birthdayFilterVisible" [nzActive]="birthdayFilterValue.length > 0"
												[nzDropdownMenu]="menuBirthday">
								<i nz-icon nzType="filter"></i>
							</nz-filter-trigger>
						</th>
					</tr>
					</thead>
					<tbody>
					<ng-template ngFor let-data [ngForOf]="dynamicTable.data">
						<tr>
							<td [nzShowExpand]="!!data.data.personal" [(nzExpand)]="data.data.personal.expanded">{{ data.id }}</td>
							<td>{{ data.data.personal.firstName }}</td>
							<td>{{ data.data.personal.lastName }}</td>
							<td>{{ data.data.personal.birthday }}</td>
						</tr>
						<tr [nzExpand]="data.data.personal.expanded">
							<td colspan="4">{{ data.data.personal.lastName }}, {{ data.data.personal.firstName }}</td>
						</tr>
					</ng-template>
					</tbody>
				</nz-table>
			</div>
		</div>
	</div>
</div>

<div nz-row>
	<div nz-col nzSpan="24">
		<div nz-row>
			<div nz-col nzSpan="24">
				<app-splitbutton [elements]="[userAddButton1]" class="tablebutton"></app-splitbutton>
			</div>
		</div>
		<div nz-row>
			<div nz-col nzSpan="24">
				<nz-table #dynamicTable [nzData]="visibleParticipants" [nzBordered]="bordered"
							[nzSimple]="simple" [nzLoading]="loading" [nzPaginationPosition]="position" [nzShowSizeChanger]="sizeChanger"
							[nzFrontPagination]="pagination" [nzShowPagination]="pagination" [nzFooter]="footer ? 'Here is the Footer' : null"
							[nzTitle]="title ? 'Here is the Title' : null" [nzSize]="size"
							class="kit__utils__table" [hidden]="privacyMode" style="overflow-x: hidden">
					<thead>
						<tr *ngIf="header">
							<th [nzChecked]="checked" [nzIndeterminate]="indeterminate" (nzCheckedChange)="onAllChecked($event)"></th>
							<th nzWidth="150px" nzCustomFilter [nzSortFn]="compareUid">
								{{ 'user.uid' | translate}}
								<nz-filter-trigger [(nzVisible)]="uidFilterVisible" [nzActive]="uidFilterValue.length > 0" [nzDropdownMenu]="menuUid">
									<i nz-icon nzType="filter"></i>
								</nz-filter-trigger>
							</th>
							<th nzWidth="150px" nzCustomFilter [nzSortFn]="compareFirstname">
								{{ 'user.firstname' | translate}}
								<nz-filter-trigger [(nzVisible)]="firstNameFilterVisible" [nzActive]="firstNameFilterValue.length > 0"
													[nzDropdownMenu]="menuFirstName">
									<i nz-icon nzType="filter"></i>
								</nz-filter-trigger>
							</th>
							<th nzWidth="150px" nzCustomFilter [nzSortFn]="compareLastname">
								{{ 'user.surname' | translate}}
								<nz-filter-trigger [(nzVisible)]="lastNameFilterVisible" [nzActive]="lastNameFilterValue.length > 0"
													[nzDropdownMenu]="menuLastName">
									<i nz-icon nzType="filter"></i>
								</nz-filter-trigger>
							</th>
							<th nzWidth="100px" nzCustomFilter [nzSortFn]="compareBirthday">
								{{ 'user.birthday' | translate}}
								<nz-filter-trigger [(nzVisible)]="birthdayFilterVisible" [nzActive]="birthdayFilterValue.length > 0"
													[nzDropdownMenu]="menuBirthday">
									<i nz-icon nzType="filter"></i>
								</nz-filter-trigger>
							</th>
						</tr>
					</thead>
					<tbody>
					<ng-template ngFor let-data [ngForOf]="dynamicTable.data">
						<tr>
							<td
									[nzChecked]="setOfCheckedId.has(data.id)"
									[nzDisabled]="data.disabled"
									(nzCheckedChange)="onItemChecked(data.id, $event)"
							></td>
							<td [nzShowExpand]="!!data.data.personal" [(nzExpand)]="data.data.personal.expanded">{{ data.id }}</td>
							<td>{{ data.data.personal.firstName }}</td>
							<td>{{ data.data.personal.lastName }}</td>
							<td>{{ data.data.personal.birthday }}</td>
						</tr>
						<tr [nzExpand]="data.data.personal.expanded">
							<td colspan="4">{{ data.data.personal.lastName }}, {{ data.data.personal.firstName }}</td>
						</tr>
					</ng-template>
					</tbody>
				</nz-table>
			</div>
		</div>
	</div>
</div>

<nz-dropdown-menu #menuUid="nzDropdownMenu">
	<div class="ant-table-filter-dropdown">
		<div class="search-box">
			<input type="text" nz-input [(ngModel)]="uidFilterValue" placeholder="{{ 'actions.searchFor' | translate :
			{searchItem : 'user.uid' | translate } }}"
					(ngModelChange)="filterUid()"/>
		</div>
	</div>
</nz-dropdown-menu>

<nz-dropdown-menu #menuFirstName="nzDropdownMenu">
	<div class="ant-table-filter-dropdown">
		<div class="search-box">
			<input type="text" nz-input [(ngModel)]="firstNameFilterValue" placeholder="{{ 'actions.searchFor' | translate :
			{searchItem : 'user.firstname' | translate } }}"
					(ngModelChange)="filterFirstName()"/>
		</div>
	</div>
</nz-dropdown-menu>

<nz-dropdown-menu #menuLastName="nzDropdownMenu">
	<div class="ant-table-filter-dropdown">
		<div class="search-box">
			<input type="text" nz-input [(ngModel)]="lastNameFilterValue" placeholder="{{ 'actions.searchFor' | translate :
			{searchItem : 'user.surname' | translate } }}"
					(ngModelChange)="filterLastName()"/>
		</div>
	</div>
</nz-dropdown-menu>

<nz-dropdown-menu #menuBirthday="nzDropdownMenu">
	<div class="ant-table-filter-dropdown">
		<div class="search-box">
			<input type="text" nz-input [(ngModel)]="birthdayFilterValue" placeholder="{{ 'actions.searchFor' | translate :
			{searchItem : 'user.birthday' | translate } }}"
					(ngModelChange)="filterBirthday()"/>
		</div>
	</div>
</nz-dropdown-menu>
